import { useEffect, useRef } from 'react';
import _isEqual from 'lodash/isEqual';
import { useForceUpdate } from './useForceUpdate';

export function usePrevious<TValue>(value: TValue, onChange?: () => void): TValue | null {
    const { forceUpdate } = useForceUpdate();
    const current = useRef<TValue | null>(value);
    const previous = useRef<TValue | null>(null);

    const isEqual = _isEqual(value, current.current);
    if (!isEqual) {
        onChange?.();
        previous.current = current.current;
        current.current = value;
    }
    useEffect(() => {
        if (!isEqual) {
            forceUpdate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEqual]);

    return previous.current;
}
